import React from 'react';
import { Card } from 'antd';

export default function MatGapAdjustmentList() {
  return (
    <Card title="GAP Material - Adjustment Transactions">
      {/* TODO: Implement adjustment transactions list */}
      Coming soon...
    </Card>
  );
}
